// extracted by mini-css-extract-plugin
module.exports = {"empty":"EmptyValue_empty__kLE_t"};